import { useEffect, useState } from 'react';
import PageHeader from '../../components/PageHeader';
import ArticleList from '../../components/ArticleList';
import blogIcon from '../../assets/images/blog-icon.png';
import {
    UPDATES_NEWS,
    UPDATES_PUBS,
} from '../../config/data';
import { t } from '../../utils/i18n';
import './index.css';

const TABS = [
    { id: 'news', label: t('新闻', 'News'), data: UPDATES_NEWS, icon: blogIcon, title: t('新闻', 'News') },
    { id: 'publications', label: t('出版物', 'Publications'), data: UPDATES_PUBS, icon: blogIcon, title: t('出版物', 'Publications') },
];

export default function UpdatesPage() {
    const [activeTab, setActiveTab] = useState('news');
    const tab = TABS.find((item) => item.id === activeTab) ?? TABS[0];

    useEffect(() => {
        document.title = t('动态 · 至知创新研究院', 'Updates · IQuest Research');
    }, []);

    return (
        <div className="page-shell">
            <PageHeader
                eyebrow="Updates"
                title={t('动态', 'Updates')}
                subtitle={t(
                    '实时同步至知创新研究院的研究成果、公司动态与官方出版物。',
                    'Research Outputs · News · Publications'
                )}
            />
            <section className="section updates-section">
                <div className="container">
                    <div className="updates-tabs">
                        {TABS.map((item) => (
                            <button
                                key={item.id}
                                className={`updates-tab${item.id === activeTab ? ' is-active' : ''}`}
                                onClick={() => setActiveTab(item.id)}
                            >
                                {item.label}
                                <span className="updates-tab-count">{item.data.length}</span>
                            </button>
                        ))}
                    </div>
                    <ArticleList
                        pageKey={tab.id}
                        title={tab.title}
                        icon={tab.icon}
                        data={tab.data}
                    />
                </div>
            </section>
        </div>
    );
}
